import React from 'react';
import ReactDOMServer from 'react-dom/server';
import { Button } from 'antd';
//import 'plugins2/gap22pages/oms/PackageOrderDetail/main/style.css';

const $ST = require(`plugins/${process.env.REACT_APP_BRAND_CODE}/platformConfigs/staticTextMaps/printableArea`);

const PrintableArea = ({
  children,
  title = '',
  trigger,
  renderButton = false,
}) => {
  const open = () => {
    const win = window.open('', 'print', 'height=400,width=100%');
    const style = `
      <style>
        @page { size: auto;  margin: 0mm; }
        @media print
        {    
          .no-print, .no-print *
          {
            display: none !important;
          }
        }
      </style>
    `;

    const closeButton = `<div style="text-align: center;padding: 10px;">
      <a class="no-print" style="padding: 15px;" href="#" onclick="window.close();">${$ST.CLOSE_PRINT_WINDOW}</a>
    </div>`;

    const content = ReactDOMServer.renderToStaticMarkup(
      <div style={{ width: 'auto', margin: '15px' }}>
        <div>{children}</div>
      </div>
    );

    win.document.write(closeButton + content + style);
    win.document.title = title;
    win.print();
  };

  return renderButton ? (
    <Button {...trigger.props} onClick={open}>
      {trigger.props.children}
    </Button>
  ) : (
    <a {...trigger.props} onClick={open}>
      {trigger.props.children}
    </a>
  );
};

export default PrintableArea;



// WEBPACK FOOTER //
// ./src/components/partials/PrintableArea.js